import { IModel } from '../../base/annotation';
import { Metamodel } from '../../base/model';

export class ModelFetchUtils {
    public static separator: string = '_$_';

    public static getModelByResourceType(type: string, subType?: string): IModel {
        try {
            return Metamodel.modelByName(subType || type);
        } catch {
            const model = ModelFetchUtils.getModelByTypeTags(type, subType);
            if (model) {
                return model;
            }
        }
        throw new Error(`Not able to find model for type - ${type} and subType - ${subType}`);
    }

    // eslint-disable-next-line
    public static getModelByTypeTags(type: string, subType?: string): IModel {
        const allModels = Metamodel.models();
        for (const model of allModels) {
            if (model.tag('type') === type && subType && model.tag('subType') && model.tag<string>('subType').toLowerCase() === subType.toLowerCase()) {
                return model;
            }
        }
        return undefined;
    }

    public static getSubTypeOwnerTypeName(subType: string): string {
        const allModels = Metamodel.models();
        const lowerCaseSubType = subType.toLowerCase();
        for (const model of allModels) {
            if (model.name.toLowerCase() === lowerCaseSubType) {
                return model.concept.name;
            }
        }
        return '';
    }
}
